import React from 'react';
import { ModalProvider, ModalRender } from 'packages/modal';

const withModal = WrappedComponent => {
  class HOC extends React.Component {
    render() {
      return (
        <ModalProvider>
          <ModalRender />
          <WrappedComponent {...this.props} />
        </ModalProvider>
      );
    }
  }

  return HOC;
};

export default withModal;



// WEBPACK FOOTER //
// /opt/build/repo/src/packages/modal/components/withModal.js